/* eslint-disable no-debugger */

// import { UserData } from '.';
// import { EnrollmentTypes } from '@api/ff-shared-services-api';

// export function getRequestValue<T>(payloadVal: T, stateVal: T): T | undefined {
// 	return payloadVal ? payloadVal : stateVal ? stateVal : undefined;
// }

// export function getRequestValueDef<T>(payloadVal: T, stateVal: T, defaultValue: T): T {
// 	return payloadVal ? payloadVal : stateVal ? stateVal : defaultValue;
// }

// export function buildPostalCode(
// 	postalCodePrefix: string | null | undefined,
// 	postalCodeSuffix: string | null | undefined
// ): string | undefined {
// 	return postalCodePrefix ? `${postalCodePrefix}${postalCodeSuffix ? '-' + postalCodeSuffix : ''}` : undefined;
// }

// export function buildPhoneNumber(
// 	phonePrefix: string | null | undefined,
// 	phoneNumber: string | null | undefined
// ): string | undefined {
// 	return phoneNumber ? `${phonePrefix ? phonePrefix : ''}${phoneNumber}` : undefined;
// }

// export function buildUsersData(usersData: UserData[] | null | undefined): EnrollmentTypes.User[] | undefined {
// 	return usersData
// 		? usersData.map(ud => {
// 				return {
// 					identityNumber: ud.idDocumentNumber,
// 					name: ud.shortName,
// 					email: ud.email,
// 					// phone: buildPhoneNumber(ud.phonePrefix, `${ud.phone}`),
// 					phone: ud.phone,
// 					profile: ud.profileAccess, // EnrollmentTypes.UserProfile.OPERATOR,
// 					userAccesses: [],
// 					identificationDocument: ud.identificationDocument.id.toString(),
// 					identificationDocumentType: ud.idDocumentType
// 						? ud.idDocumentType
// 						: EnrollmentTypes.UserIdentificationDocumentType.CC,
// 				} as EnrollmentTypes.User;
// 		  })
// 		: undefined;
// }

import { UserData } from '.';
import { EnrollmentTypes } from '@api/ff-shared-services-api';
import { CoreHelper } from 'ff-shared-components-core';

export function getRequestValue<T>(payloadVal: T, stateVal: T): T | undefined {
	return payloadVal ? payloadVal : stateVal ? stateVal : undefined;
}

export function getRequestValueDef<T>(payloadVal: T, stateVal: T, defaultValue: T): T {
	return payloadVal ? payloadVal : stateVal ? stateVal : defaultValue;
}

export function buildPostalCode(
	postalCodePrefix: string | null | undefined,
	postalCodeSuffix: string | null | undefined
): string | undefined {
	return postalCodePrefix ? `${postalCodePrefix}${postalCodeSuffix ? '-' + postalCodeSuffix : ''}` : undefined;
}

export function buildPhoneNumber(
	phonePrefix: string | null | undefined,
	phoneNumber: string | null | undefined
): string | undefined {
	return phoneNumber ? `${phonePrefix ? phonePrefix : ''}${phoneNumber}` : undefined;
}

export function buildUsersData(usersData: UserData[] | null | undefined): EnrollmentTypes.User[] | undefined {
	//debugger;
	return usersData
		? usersData.map(ud => {
				return {
					identityNumber: ud.idDocumentNumber,
					name: ud.shortName,
					email: ud.email,
					phoneCountry: ud.phonePrefix,
					phone: ud.phone,
					profile: ud.profileAccess,
					// customAccesses: ud.customAccesses ? ud.customAccesses : undefined,
					// userAccesses: ud.userAccesses ? ud.userAccesses : [],
					customAccesses: undefined,
					userAccesses: [],
					identificationDocument: ud.identificationDocument.id.toString(),
					identificationDocumentType: ud.idDocumentType
						? ud.idDocumentType
						: EnrollmentTypes.UserIdentificationDocumentType.CC,
				} as EnrollmentTypes.User;
		  })
		: undefined;
}

/* cspell: disable*/
// eslint-disable-next-line sonarjs/cognitive-complexity
export function buildUsersStateFomData(usersData: EnrollmentTypes.User[] | undefined): UserData[] | undefined {
	return usersData
		? usersData.map(ud => {
				return {
					id: CoreHelper.guid(),
					idDocumentType: ud.identificationDocumentType
						? ud.identificationDocumentType
						: EnrollmentTypes.UserIdentificationDocumentType.CC,
					idDocumentNumber: ud.identityNumber,
					shortName: ud.name ? ud.name : '',
					email: ud.email ? ud.email : '',
					phonePrefix: ud.phoneCountry ? ud.phoneCountry : '',
					phone: ud.phone ? ud.phone : '',
					profileAccess: ud.profile,
					userAccesses: ud.userAccesses ? ud.userAccesses : [],
					customAccesses: ud.customAccesses,
					identificationDocument: {
						id: ud.identificationDocument,
						fileName: 'comprovativo',
						isDownloadable: true,
					},
				} as UserData;
		  })
		: undefined;
}

export function getRequestStepNameByIndex(stepIndex: number): EnrollmentTypes.RequestStep | undefined {
	//debugger;
	switch (stepIndex) {
		case 1:
			return EnrollmentTypes.RequestStep.WEB_STEP_2;
		case 2:
			return EnrollmentTypes.RequestStep.WEB_STEP_3;
		case 3:
			return EnrollmentTypes.RequestStep.WEB_STEP_4;
		// case 4:
		// 	return EnrollmentTypes.RequestStep.WEB_STEP_4;
		default:
			return undefined;
	}
}
